import { useUIColors } from '@/core/hooks';
import React from 'react';
import { View, ViewProps } from 'react-native';

export interface CardProps extends Omit<ViewProps, 'style'> {
    variant?: 'default' | 'glassmorphism' | 'transparent';
    padding?: number;
    style?: ViewProps['style'];
}

export const Card = React.memo<CardProps>(function Card({
    variant = 'default',
    padding = 16,
    style,
    children,
    ...props
}) {
    const colors = useUIColors();

    const getCardStyle = () => {
        switch (variant) {
            case 'glassmorphism':
                return {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)', // Semi-transparent white
                    borderRadius: 16,
                    // Note: Backdrop blur is limited in React Native
                    // We simulate glassmorphism with semi-transparent background
                };
            case 'transparent':
                return {
                    backgroundColor: 'transparent',
                    borderRadius: 16,
                };
            case 'default':
            default:
                return {
                    backgroundColor: colors.backgroundLevel3,
                    borderRadius: 8,
                    shadowColor: colors.fontHighContrast,
                    shadowOffset: {
                        width: 0,
                        height: 2,
                    },
                    shadowOpacity: 0.1,
                    shadowRadius: 4,
                    elevation: 3, // Android shadow
                };
        }
    };

    return (
        <View
            style={[
                getCardStyle(),
                { padding },
                style
            ]}
            {...props}
        >
            {children}
        </View>
    );
});

export default Card;
